import * as React from 'react';

export function FileMusicSvg(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg data-name="Layer 1" viewBox="0 0 24 24" width="1em" height="1em" {...props}>
      <path d="M15 12a1 1 0 01-1 1h-1v4.5a2.5 2.5 0 11-2.5-2.5 2.577 2.577 0 01.5.05V13a2 2 0 012-2h1a1 1 0 011 1zm7-1.515V19a5.006 5.006 0 01-5 5H7a5.006 5.006 0 01-5-5V5a5.006 5.006 0 015-5h4.515a6.955 6.955 0 014.95 2.051l3.484 3.484A6.955 6.955 0 0122 10.485zm-6.949-7.02A4.989 4.989 0 0014 2.684V7a1 1 0 001 1h4.316a4.989 4.989 0 00-.781-1.051zM20 10.485c0-.165-.032-.323-.047-.485H15a3 3 0 01-3-3V2.047c-.162-.015-.32-.047-.485-.047H7a3 3 0 00-3 3v14a3 3 0 003 3h10a3 3 0 003-3z" />
    </svg>
  );
}
